import React from 'react';

import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { BlockType, WidgetType } from '../../types/api/ElementType';
import { NewsletterSettingsBlock } from '../../_blocks/NewsletterSettings/NewsletterSettingsBlock';
import { AccessKeysSettingsBlock } from '../../_blocks/AccessKeysSettings';
import { ColorSchemeSettingsBlock } from '../../_blocks/ColorSchemeSettings/ColorSchemeSettingsBlock';
import { DefaultAccordion } from '../../_lib/components/Accordion/DefaultAccordion';
import { Icons } from '../../components/atoms/SVG';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type PersonalSettingsWidget = WidgetShape<
  [NewsletterSettingsBlock, AccessKeysSettingsBlock, ColorSchemeSettingsBlock],
  WidgetType.personalsettings
>;

export function PersonalSettingsWidget({ blocks, elementType, ...headerProps }: PersonalSettingsWidget) {
  const { t } = useSonTranslation('Widget');

  const accordionData = blocks.map(block => ({
    key: block.uuid,
    id: `${block.elementType}-${block.uuid}`,
    category: t(block.elementType as any),
    props: block,
  }));
  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      icon={Icons.SETTINGS}
      widgetType={elementType}
      hierarchy={3}
      title={t(`header.${elementType}`)}
    >
      <DefaultAccordion data={accordionData} headlineHierarchy={4}>
        {({ props }) => {
          switch (props.elementType) {
            case BlockType.newslettersettings:
              return <NewsletterSettingsBlock {...props} />;
            case BlockType.accesskeyssettings:
              return <AccessKeysSettingsBlock {...props} />;
            case BlockType.colorschemesettings:
              return <ColorSchemeSettingsBlock {...props} />;
            default:
              return null;
          }
        }}
      </DefaultAccordion>
    </DefaultWidgetWithHeader>
  );
}
